import { render } from "./like.vue?vue&type=template&id=60716dea&scoped=true"
import script from "./like.vue?vue&type=script&lang=js"
export * from "./like.vue?vue&type=script&lang=js"

import "./like.vue?vue&type=style&index=0&id=60716dea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60716dea"]])

export default __exports__